var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.crossRegion)?_c('feature-flag',{attrs:{"name":"crossRegion.activeStatusTag"}},[(_vm.isReady && _vm.cluster)?_c(_vm.tag,{tag:"component",staticClass:"active-status",class:{
            [_vm.classname]: _vm.classname,
        },attrs:{"name":"activeStatus","options":_vm.selectList,"value":_vm.cluster},on:{"change":_vm.onClusterChange}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }